"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.74-.06H2.23a.57.57,0,0,0-.64.64V20.09a.57.57,0,0,0,.64.64H8.62l3.2,3.15a.24.24,0,0,0,.17.06.23.23,0,0,0,.16-.06l3.21-3.15h6.38a.56.56,0,0,0,.64-.64V.58A.57.57,0,0,0,21.74-.06Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.66,10a.63.63,0,0,0-.63.63.63.63,0,1,0,1.26,0A.63.63,0,0,0,9.66,10Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.71,10a.63.63,0,0,0-.63.63.63.63,0,1,0,1.25,0A.63.63,0,0,0,4.71,10Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.13,7.12h6.66A.12.12,0,0,0,10.92,7l-.46-2.4a.19.19,0,0,0-.19-.16H5a.23.23,0,0,0-.2.15L4,7A.11.11,0,0,0,4.13,7.12Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.9,14.75H9.08a.16.16,0,0,0-.16.16v.39a.16.16,0,0,1-.16.16H6.44a.16.16,0,0,1-.16-.16v-.41a.16.16,0,0,0-.16-.16H4.52a.16.16,0,0,0-.16.16v.36a.16.16,0,0,1-.16.16H3.31a.16.16,0,0,0-.16.16v.66a.16.16,0,0,0,.16.16h8.44A.58.58,0,0,0,12,16.3a5.18,5.18,0,0,1,2-.53h.06A2.57,2.57,0,0,1,12.9,14.75Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.44,10.43l-.14-.06a12,12,0,0,1-3.58-3.15c-.05-.07-.09-.06-.09,0V12.7a2.56,2.56,0,0,1,3.95-1.38v-.66A.27.27,0,0,0,16.44,10.43Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.1,12l1-.58-.05,0-1.74-.57a.12.12,0,0,0-.15.12v1a2.85,2.85,0,0,1,.39.78A1,1,0,0,1,18.1,12Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.55,14.09l.32,0h7a.16.16,0,0,0,.16-.16V6.32h0A.81.81,0,0,0,12,6a13.61,13.61,0,0,0-.93-1.91,1.32,1.32,0,0,0-.89-.51H4.92c-.17,0-.29.17-.43.37s-1,2.78-1.05,3.13S3.26,8,3.26,8s0,.23,0,.31l-.08,3v.9c0,.26,0,.31.47,1.13S4.55,14.09,4.55,14.09Zm.16-2.87a.63.63,0,0,1-.63-.63.63.63,0,1,1,.63.63Zm5,0A.63.63,0,0,1,9,10.59a.63.63,0,0,1,1.26,0A.63.63,0,0,1,9.66,11.22ZM4.77,4.56A.23.23,0,0,1,5,4.41h5.3a.19.19,0,0,1,.19.16L10.92,7a.12.12,0,0,1-.13.15H4.13A.11.11,0,0,1,4,7Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.49,14.68l1.08,1.06.84-.84-1.07-1.07A1.34,1.34,0,0,0,16,12.45a1.31,1.31,0,0,0-1.44-.28.12.12,0,0,0-.09.1.14.14,0,0,0,0,.13L15,13v.39h-.39l-.57-.53a.12.12,0,0,0-.13,0,.14.14,0,0,0-.11.09,1.33,1.33,0,0,0,.29,1.46A1.36,1.36,0,0,0,15.49,14.68Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.06,16.55l-1-1-.84.85,1,1a1.34,1.34,0,0,0,.32,1.37,1.31,1.31,0,0,0,.95.39,1.39,1.39,0,0,0,.53-.1A.15.15,0,0,0,20.1,19a.12.12,0,0,0,0-.13l-.56-.59v-.38h.39l.6.55a.15.15,0,0,0,.13,0,.17.17,0,0,0,.11-.09,1.33,1.33,0,0,0-.29-1.47A1.38,1.38,0,0,0,19.06,16.55Z",
    fill: "#fff"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.84,12.55l-.44-.45a.15.15,0,0,0-.19,0l-1.06.74a.11.11,0,0,0-.06.11.12.12,0,0,0,0,.11l.28.28-3,3-.53-.52a.15.15,0,0,0-.21.21l.21.21L14.06,18a.6.6,0,0,0,0,.84.58.58,0,0,0,.84,0L16.76,17l.21.21a.12.12,0,0,0,.1,0,.15.15,0,0,0,.11,0,.17.17,0,0,0,0-.21l-.53-.53,3-3,.25.25a.13.13,0,0,0,.1,0h0a.11.11,0,0,0,.11-.06l.77-1A.14.14,0,0,0,20.84,12.55Z",
    fill: "#fff"
  }));
};

exports["default"] = _default;